export default "__VITE_ASSET__CKmITZCQ__"